export default "__VITE_ASSET__CQQLNNg3__"